import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MTACardTypeService } from "../report-services/mta-card-type.service";
import * as moment from "moment";

@Component({
	templateUrl: "./cardusageduringschoolabsence.component.html",
})
export class CardUsageDuringSchoolAbsenceComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private mtacardtypeService: MTACardTypeService,
		private districtschoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		DistrictSchoolID: 0,
		MTACardTypeID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		SortByID: "Date",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	DistrictSchoolList: any = [];
	MTACardTypeList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		//Insert Custom List Items Here
		{
			SortByID: "Date",
			SortByName: "Date",
		},
		{
			SortByID: "Farebox",
			SortByName: "Farebox",
		},
		{
			SortByID: "Name",
			SortByName: "Name",
		},
		{
			SortByID: "School",
			SortByName: "School",
		},
		{
			SortByID: "UID",
			SortByName: "UID",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 407;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadDistrictSchoolList()
		// this.loadMTACardTypeList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onDistrictSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onDistrictSchoolChange(value) {
		this.report.SchoolID = value;
		this.report.DistrictSchoolID = value;
		this.loadMTACardTypeList();
		this.loadLogolist();
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				if (this.DistrictSchoolList.length > 1) {
					// this.DistrictSchoolList.unshift({
					//     DistrictSchoolID: 0,
					//     DistrictSchoolDesc: "All DistrictSchools"
					// })
				} else {
					this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
				}
			},
			(error) => {}
		);
	}

	private loadMTACardTypeList() {
		this.report.MTACardTypeID = 0;
		var result = this.mtacardtypeService.loadMTACardTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.MTACardTypeList = response;

				if (this.MTACardTypeList.length > 1) {
					// this.MTACardTypeList.unshift({
					//     MTACardTypeID: 0,
					//     MTACardTypeDesc: "All MTACardTypes"
					// })
				} else {
					this.report.MTACardTypeID = this.MTACardTypeList[0].MTACardTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.DistrictSchoolID) {
		// 	this.errorMessage = "Select the DistrictSchool"
		// 	return;
		// }

		// if (!this.report.MTACardTypeID) {
		// 	this.errorMessage = "Select the MTACardType"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.SortByID) {
		// 	this.errorMessage = "Select the SortBy"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 407;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: DistrictSchoolID
		strParam += this.report.DistrictSchoolID + "|DistrictSchoolID";

		//Parameter 2: MTACardTypeID
		strParam += "," + this.report.MTACardTypeID + "|MTACardTypeID";

		//Parameter 3: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 4: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 5: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
